import { ApiProperty, ApiPropertyOptional } from '@nestjs/swagger';

export class LightActivityTypeResponseDto {
  @ApiProperty({ type: 'string' })
  id!: string;

  @ApiProperty({ type: 'string' })
  code!: string;

  @ApiProperty({ type: 'string' })
  label!: string;

  @ApiPropertyOptional({ type: 'string', nullable: true })
  description!: string | null;
}
